import React, { Component } from 'react';
import '../../../styles/scss/style.css';

//Returning the component
class FormToggleSwitch extends Component {
	render() {
		return (
			<label className="toggleSwitch">
				<input type="checkbox" checked={this.props.active} onChange={this.props.onChange}/>
				<span className="toggleSwitch_slider"></span>
			</label>
		)
	}
}

export default FormToggleSwitch;


// WEBPACK FOOTER //
// ./src/redux/components/atoms/FormToggleSwitch.jsx